import React from 'react';
import styled from 'styled-components';

import Lottie from 'lottie-react-web';
import { PreloaderPresto } from '../../assets/images';
import { PrestoAppTheme } from 'presto-mini-apps-lib';

function Loader({
    isShown = false,
}) {
    return (
        <LoaderWrapper className={[
            "overlay-content",
            (!!isShown ? ' show' : '')
        ].join('')}>
            <div className="overlay">
                <div className="container">
                    <Lottie
                        options={{
                            animationData: PreloaderPresto
                        }}
                    />
                </div>
            </div>
        </LoaderWrapper>
    );
}

export default Loader;

const LoaderWrapper = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 999;

    & .overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(${PrestoAppTheme.colors.whiteRGB}, .65);

        & .container {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transform: -webkit-translate(-50%, -50%);
            transform: -moz-translate(-50%, -50%);
            transform: -ms-translate(-50%, -50%);
        }

    }

    &.show {
        display: flex;
    }
`;